module.exports = __webpack_public_path__ + "img/keyboard.65bf102b.svg";